import React, { useEffect } from "react";
import { Button } from "reactstrap";

export const List = ({
  t,
  setSelectedRowId,
  setSelectedStageId,
  UpdateItemToggle,
  stage,
  index,
}) => {

  const handleAddRowToggleModal = (stage_id) => {
    setSelectedRowId(null);
    setSelectedStageId(stage_id);
    UpdateItemToggle(true);
  };

  return (
    <tr className={`border-top ${index % 2 === 0 ? "bg-light" : "bg-white"}`}>
      <td colSpan="100%" className={`text-nowrap ${stage?.color_class}`}>
        <div className={`d-flex align-items-center w-100 p-1 ${stage?.color_class}`}>
          <div className="">
            <span>{stage?.name}</span>
          </div>
          <div className="ml-2">
            <Button
              className="ml-auto clickable border-0 btn-link text-dark p-0 shadow-none"
              onClick={() => handleAddRowToggleModal(stage?.id)}
            >
              <i className="fa fa-plus"></i>
            </Button>
          </div>
        </div>
      </td>
    </tr>
  );
};

export default List;
